import { useState, useEffect } from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { Flex } from 'components/base/layout-components';
import { StyledCalendarWrapper } from './Calendar.style';
import { DEFAULT_CALENDAR_DATES } from '../../../periods/constants';
import { LBButton } from '@linearb/buzz';
import HeadsUpAlert from './HeadsUpAlert';

const Calendar = ({ selectedPeriod, onChange, isCustomDateOutsideRange }) => {
  const {
    before = DEFAULT_CALENDAR_DATES.before,
    after = DEFAULT_CALENDAR_DATES.after,
    isReadOnlyCalendar = true,
    periodKey
  } = selectedPeriod;

  const [customPeriod, setCustomPeriod] = useState({
    after,
    before
  });
  const [focusedInput, setFocusedInput] = useState('startDate');
  const [initialMonth, setInitialMonth] = useState(moment(before));
  const [shouldShowHeadsUp, setShouldShowHeadsUp] = useState(false);

  const isDateOutsideRange = date =>
    isReadOnlyCalendar
      ? date.isBefore(customPeriod.after, 'day') ||
        date.isAfter(customPeriod.before, 'day')
      : isCustomDateOutsideRange
      ? isCustomDateOutsideRange(date)
      : date.isAfter(moment().endOf('day'));

  useEffect(() => {
    setCustomPeriod({ after, before });
    setFocusedInput('startDate');
    setInitialMonth(null);
    setTimeout(() => setInitialMonth(moment(before)), 0);
  }, [periodKey]);

  return (
    <StyledCalendarWrapper readOnly={isReadOnlyCalendar}>
      {initialMonth && (
        <>
          <Flex grow='1'>
            <div
              style={{ width: '18rem', height: '30rem', textAlign: 'center' }}
            >
              <DateRangePicker
                isOutsideRange={date => isDateOutsideRange(date)}
                hideKeyboardShortcutsPanel={true}
                startDate={moment(customPeriod.after)}
                startDateId='startDateId'
                endDate={moment(customPeriod.before)}
                endDateId='endDateId'
                focusedInput={focusedInput}
                onFocusChange={input => {
                  setFocusedInput(input || 'startDate');
                }}
                transitionDuration={0}
                initialVisibleMonth={() => initialMonth.subtract(1, 'month')}
                onDatesChange={({ startDate, endDate }) => {
                  const customRange = {
                    before: endDate || moment(),
                    after: startDate
                  };
                  const duration = moment.duration(
                    customRange.before.diff(customRange.after)
                  );
                  const shouldShowHeadsUp = duration.asMonths() > 6;
                  setShouldShowHeadsUp(shouldShowHeadsUp);
                  setCustomPeriod(customRange);
                }}
              />
            </div>
          </Flex>
          <div className='row flex items-center justify-between '>
            <div className={`${shouldShowHeadsUp ? 'visible' : 'invisible'}`}>
              <HeadsUpAlert />
            </div>
            <LBButton
              data-cy='period-picker-apply-button'
              onClick={() => {
                onChange({
                  start_date: moment(customPeriod.after).format(
                    SEARCH_DATE_FORMAT
                  ),
                  end_date: moment(customPeriod.before).format(
                    SEARCH_DATE_FORMAT
                  ),
                  selectedPeriodKey: periodKey
                });
              }}
            >
              Apply
            </LBButton>
          </div>
        </>
      )}
    </StyledCalendarWrapper>
  );
};

export default Calendar;
